import script from "./DatasetManifest.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetManifest.vue?vue&type=script&setup=true&lang=ts"

import "./DatasetManifest.vue?vue&type=style&index=0&id=5dfb9e96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dfb9e96"]])

export default __exports__